import React, { useState, useCallback, useEffect, useRef } from 'react';
import useChatStore from './useChatStore';
import './OuterChatbox.css';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import axios from "../../API/axios";
import DoneAllSharpIcon from '@mui/icons-material/DoneAllSharp';
import moment from 'moment';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import DropDownBox from './DropDownBox';

const ChatBox = ({ user }) => {
    const currentUserProfilPic = localStorage.getItem("profilPic");
    const sessionId = localStorage.getItem("sessionId");
    const [showDropdown, setShowDropdown] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const [selectedMessageId, setSelectedMessageId] = useState(null);
    const { removeChat, toggleChat, updateInput, updateMessages, storeMessages, setMessageID, setMsgIDDirect, getMessageList } = useChatStore();

    const footerRef = useRef();

    const sendMessageHandler = useCallback(() => {
        try {
            if (user.inputValue.length) {
                if (!user.messages.length) {
                    InitiateMessage();
                } else {
                    ReplyMessage();
                }
            }
        } catch (error) {
            console.log(error);
        }
    }, [user.inputValue])


    const getChatList = useCallback(async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            toUserUid: user.userUid,
        };
        axios
            .post(`Message/GetUserChat`, data)
            .then((response) => {
                // console.log(response);
                // toggleChat(user.userUid);
                const res = response.data.responseData.chatList;
                storeMessages(user.userUid, res);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [user.userUid, user.messages, user.inputValue]);

    const ReplyMessage = useCallback(async () => {
        const messageDetails = {
            deviceType: "Web",
            sessionId: sessionId,
            msgID: user.msgID,
            type: 1,
            msg: user.inputValue,
        };
        try {
            await axios
                .post("Message/ReplyMessage", messageDetails)
                .then((response) => {
                    if (response.status == 200 && response.data.status === "Success") {
                        updateInput(user.userUid, "");
                        getChatList();
                    }
                    console.log("response", response);
                });

        } catch (error) {
            console.log(error);
        }
    }, [user.userUid, user.messages, user.inputValue]);

    const InitiateMessage = useCallback(async () => {
        const messageDetails = {
            deviceType: "Web",
            sessionId: sessionId,
            type: 1,
            msg: user.inputValue,
            toUserUid: user.userUid,
        };

        try {
            await axios
                .post("Message/InitiateMessage", messageDetails)
                .then((response) => {
                    updateInput(user.userUid, "");
                    getChatList();
                    getMessageList();
                    setMsgIDDirect(user.userUid, response.data.responseData.id);
                });

        } catch (error) {
            console.log(error);
        }
    }, [user.userUid, user.messages, user.inputValue]);

    useEffect(() => {
        getChatList();
        setMessageID(user.userUid);
    }, [user.userUid]);

    useEffect(() => {
        if (footerRef.current && user.isOpen) {
            footerRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [user.messages, user.isOpen]);

    const inputChangeHandler = useCallback((userId, value) => {
        try {
            updateInput(userId, value);
        } catch (error) {
            console.log(error);
        }
    }, [user.inputValue]);


    const handleMoreOptions = (event, record) => {
        try {
            event.stopPropagation(); // Prevent unwanted bubbling

            // const rect = event.currentTarget.getBoundingClientRect();
            // setDropdownPosition({
            //     top: rect.top,
            //     left: record.isOwned ? rect.left : rect.right + 220, // Align left for sent messages, right for received
            // });
            setShowDropdown(true);
            setSelectedMessageId(prevId => (prevId === record.chatID ? null : record.chatID));
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className={`chat-box ${user.isOpen ? 'open' : 'closed'}`}>
            <div className="chat-header" onClick={() => toggleChat(user.userUid)}>
                <div className='outer-chat-box-header-img-fullname'>
                    <img src={user.profilPic} alt="" width={35} height={35} style={{ borderRadius: "50px" }} />
                    <div className='outer-chat-box-username'>{user.fullName}</div>
                </div>
                <CloseSharpIcon onClick={() => removeChat(user.userUid)} />
            </div>
            {/* {
                user.isOpen && (
                    <div className="chat-messages">
                        {user.messages.map((record, index) => (
                            <div
                                key={index}
                                className={`message-container ${record.isOwned ? "owned" : "received"}`}
                                ref={footerRef}
                            >
                                {!record.isOwned && (
                                    <img
                                        src={user.profilPic}
                                        alt="Profile"
                                        className="message-avatar"
                                    />
                                )}

                                {!record.isOwned && <MoreHorizSharpIcon className='more-options' />}
                                <div className="message-bubble">
                                    {record.msg}
                                    <div className="message-time">
                                        {moment.utc(record.time).local().format("LT")}
                                        {record.isOwned && <span className="message-status">
                                            {record?.isRead === false ? (
                                                <DoneAllSharpIcon className="material-symbols-sharp" style={{ width: '15px' }} />
                                            ) : (
                                                <DoneAllSharpIcon className="material-symbols-sharp text-read" style={{ width: '15px' }} />
                                            )}
                                        </span>}
                                    </div>
                                </div>

                                {record.isOwned && <MoreHorizSharpIcon className='more-options' />}

                                {record.isOwned && (
                                    <img
                                        src={currentUserProfilPic}
                                        alt="Profile"
                                        className="message-avatar"
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                )
            } */}
            {
                user.isOpen && (
                    <div className="chat-messages">
                        {user.messages.map((record, index) => (
                            <div
                                key={index}
                                className={`message-container ${record.isOwned ? "owned" : "received"}`}
                                ref={footerRef}
                            >
                                {/* Layout for Received Messages */}
                                {!record.isOwned && !record.isDeleted && (
                                    <>
                                        <img
                                            src={user.profilPic}
                                            alt="Profile"
                                            className="message-avatar"
                                        />
                                        <div className="message-bubble f-10 f-400">{record.msg}
                                            <div className="message-time">
                                                {moment.utc(record.time).local().format("LT")}
                                            </div>
                                        </div>
                                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                            {
                                                selectedMessageId === record.chatID && <DropDownBox
                                                    visible={showDropdown}
                                                    setVisibility={setShowDropdown}
                                                    record={record}
                                                // style={{
                                                //     position: "absolute",
                                                //     top: `${dropdownPosition.top}px`,
                                                //     left: `${dropdownPosition.left}px`,
                                                //     transform: "translateY(-50%)",
                                                //     zIndex: 1000
                                                // }}
                                                />
                                            }
                                            <MoreHorizSharpIcon className="material-symbols-sharp" onClick={(e) => handleMoreOptions(e, record)} />
                                        </div>
                                    </>
                                )}

                                {/* Layout for Sent Messages */}
                                {record.isOwned && !record.isDeleted && (
                                    <>
                                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                            {
                                                selectedMessageId === record.chatID && <DropDownBox
                                                    visible={showDropdown}
                                                    setVisibility={setShowDropdown}
                                                    record={record}
                                                // style={{
                                                //     position: "absolute",
                                                //     top: `${dropdownPosition.top}px`,
                                                //     left: `${dropdownPosition.left}px`,
                                                //     transform: "translateY(-50%)",
                                                //     zIndex: 1000
                                                // }}
                                                />
                                            }
                                            <MoreHorizSharpIcon className="material-symbols-sharp" onClick={(e) => handleMoreOptions(e, record)} />
                                        </div>
                                        <div className="message-bubble f-10 f-400">
                                            {record.msg}
                                            <div className="message-time">
                                                {moment.utc(record.time).local().format("LT")}
                                                <span className="message-status">
                                                    {record?.isRead === false ? (
                                                        <DoneAllSharpIcon className="material-symbols-sharp" style={{ width: '15px' }} />
                                                    ) : (
                                                        <DoneAllSharpIcon className="material-symbols-sharp text-read" style={{ width: '15px' }} />
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <img
                                            src={currentUserProfilPic}
                                            alt="Profile"
                                            className="message-avatar"
                                        />
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                )
            }
            {user.isOpen && (
                <div className="chat-input">
                    <img
                        src={currentUserProfilPic}
                        alt="user Image"
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                    />
                    <input
                        type="text"
                        value={user.inputValue}
                        onChange={(e) => inputChangeHandler(user.userUid, e.target.value)}
                        placeholder="Write messages down here…"
                        onKeyPress={(e) => e.key === "Enter" && sendMessageHandler()}
                    />
                    <SendSharpIcon
                        // className="send-btn"
                        className='material-symbols-sharp'
                        onClick={() => sendMessageHandler()}
                        style={{ cursor: "pointer" }}
                    />
                </div>
            )}
        </div>
    );
};

export default ChatBox;


/* ------------------------
-----------------------------------------------
Issue present in code base of outerChatBox.jsx
-----------------------------------------------
1. Input is send as empty to initial Api. (done)
2. Need to check for multiple user issue once message is send then it also show in other chat window(done)
3. Need to check with GetMessageList api as it is send only one record.(done)
4. CSS Responseness and dark and light theme(done).
5. Need to hide the chatbox when user sign out (done).
6. The message are not sending on second click chatbox (done).
7. Need to hide the chatbox on messaging screen (done).
*/